module.exports = __webpack_public_path__ + "static/media/yashita_jhurani.d128859d.jpg";